<div class="ips-container" [class.ips-disabled]="isReadonly">
	<!-- Search bar -->
	<form [formGroup]="searchForm" (ngSubmit)="onSearch()" class="ips-search-bar">
		<div *ngFor="let f of searchFields" class="ips-search-field-wrapper">
			<label class="ips-field-label" [for]="f.key">{{ f.searchCriteriaLabel || f.label }}</label>
			<mat-form-field class="ips-search-field">
				<input
					matInput
					[id]="f.key"
					[formControlName]="f.key"
					[placeholder]="f.placeholder || ''"
					[type]="f.type || 'text'"
					[attr.maxlength]="f.maxLength || null"
					[attr.aria-describedby]="isFromCall(f.key) ? f.key + '_fromCall' : null"
				/>
			</mat-form-field>
			<span *ngIf="isFromCall(f.key)" class="ips-from-call" [id]="f.key + '_fromCall'"> From call </span>
		</div>

		<div class="ips-search-actions">
			<button mat-raised-button color="primary" type="submit" [disabled]="isReadonly || isLoading">Search</button>
			<button *ngIf="hasSearched || results.length" mat-button type="button" (click)="clearSearch()">
				Clear
			</button>
		</div>
	</form>

	<!-- Loading indicator -->
	<div *ngIf="isLoading" class="ips-status" role="status">
		<mat-spinner diameter="20"></mat-spinner>
		<span>Searching…</span>
	</div>

	<!-- External data refresh of the selected row -->
	<div *ngIf="isSyncing" class="ips-status" role="status">
		<mat-spinner diameter="20"></mat-spinner>
		<span>Updating member data…</span>
	</div>

	<!-- The refresh failed: the row shown may be stale, but verification is still allowed -->
	<div *ngIf="syncWarning" class="ips-status ips-sync-warning" role="alert">
		<span>{{ syncWarning }}</span>
	</div>

	<!-- No results message -->
	<div *ngIf="!isLoading && hasSearched && results.length === 0" class="ips-status ips-no-results" role="status">
		{{ noResultsMessage }}
	</div>

	<!-- Verification count badge -->
	<div
		*ngIf="totalCheckboxCount > 0 && selectedIndex !== null"
		class="ips-verification-badge"
		[class.ips-verification-badge--met]="isVerificationMet"
		[class.ips-verification-badge--error]="!isVerificationMet"
	>
		<span>{{ verifiedCount }} / {{ requiredVerifications }} Verified</span>
	</div>

	<!-- Results table -->
	<div *ngIf="!isLoading && results.length > 0" class="ips-results-wrapper">
		<table class="ips-table" aria-label="Search results" [attr.aria-busy]="isSyncing">
			<thead>
				<tr>
					<th class="ips-col-radio" scope="col" aria-label="Select"></th>
					<th
						*ngFor="let col of columns"
						scope="col"
						class="ips-th-sortable"
						tabindex="0"
						(click)="toggleSort(col.key)"
						(keyup.enter)="toggleSort(col.key)"
						(keyup.space)="$event.preventDefault(); toggleSort(col.key)"
						[attr.aria-sort]="sortKey === col.key ? (sortAsc ? 'ascending' : 'descending') : 'none'"
					>
						{{ col.label }}
						<span *ngIf="sortKey === col.key" class="ips-sort-indicator" aria-hidden="true">
							{{ sortAsc ? '▲' : '▼' }}
						</span>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr
					*ngFor="let entry of pagedResults"
					class="ips-row"
					[class.ips-row--selected]="selectedIndex === entry.originalIndex"
					(click)="selectRow(entry.originalIndex)"
				>
					<!-- Radio button — stop propagation so click doesn't double-fire -->
					<td class="ips-col-radio" (click)="$event.stopPropagation()">
						<mat-radio-button
							[checked]="selectedIndex === entry.originalIndex"
							[disabled]="isReadonly"
							[aria-label]="'Select row ' + (entry.originalIndex + 1)"
							(change)="selectRow(entry.originalIndex)"
						></mat-radio-button>
					</td>

					<!-- Data columns — each may include an inline checkbox when the row is selected -->
					<td *ngFor="let col of columns">
						<div class="ips-cell">
							<mat-checkbox
								*ngIf="col.checkbox"
								class="ips-cell-checkbox"
								[aria-label]="checkboxAriaLabel(col)"
								[class.ips-cell-checkbox--hidden]="
									selectedIndex !== entry.originalIndex || formatCell(entry.row, col) === ''
								"
								[(ngModel)]="checkboxStates[entry.originalIndex][col.checkbox.key]"
								(ngModelChange)="onCheckboxChange()"
								(click)="$event.stopPropagation()"
								[disabled]="
									isReadonly ||
									isSyncing ||
									selectedIndex !== entry.originalIndex ||
									formatCell(entry.row, col) === ''
								"
							></mat-checkbox>
							<span class="ips-cell-value">{{ formatCell(entry.row, col) }}</span>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<mat-paginator
			*ngIf="results.length > pageSize"
			class="ips-paginator"
			[length]="results.length"
			[pageSize]="pageSize"
			[pageIndex]="pageIndex"
			[hidePageSize]="true"
			[showFirstLastButtons]="true"
			aria-label="Search results pages"
			(page)="onPageChange($event)"
		></mat-paginator>
	</div>
</div>

<input
	[id]="field.id ?? ''"
	[name]="field.id ?? ''"
	type="hidden"
	[formControl]="formControl"
	[formlyAttributes]="field"
/>
